var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrademark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M607.875 98.719C588.719 91.906 567.281 98.094 554.531 114L464 227.156L373.469 114C360.719 98.062 339.219 91.875 320.125 98.719C300.875 105.469 288 123.625 288 144V368C288 394.5 309.5 416 336 416S384 394.5 384 368V280.844L426.531 334C444.719 356.75 483.281 356.75 501.469 334L544 280.844V368C544 394.5 565.5 416 592 416S640 394.5 640 368V144C640 123.625 627.125 105.469 607.875 98.719ZM208 96H48C21.5 96 0 117.5 0 144S21.5 192 48 192H80V368C80 394.5 101.5 416 128 416S176 394.5 176 368V192H208C234.5 192 256 170.5 256 144S234.5 96 208 96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrademark);
export default __webpack_public_path__ + "static/media/trademark.4599cf304b9d5f87144a4bcaad39db49.svg";
export { ForwardRef as ReactComponent };